import React from 'react';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons';
import { NewsItemModel } from '../../../../api-service/clients';
import { LinkIcon } from '../../../../components/icons/link-icon/link-icon';

export interface INewsItemIconsProps {
  newsItem: NewsItemModel;
}

export function NewsItemIcons(props: INewsItemIconsProps) {
  const { newsItem } = props;

  return (
    <Box display="flex" gap={1}>
      {!!newsItem.attachments?.length && (
        <span title="Har vedhæftede filer">
          <FontAwesomeIcon icon={faPaperclip} />
        </span>
      )}
      {newsItem.url && (
        <span title="Har link">
          <LinkIcon />
        </span>
      )}
    </Box>
  );
}
